import { faBuildings, faCaretDown, faCircleCheck, faCircleUser, faClose, faRightFromBracket} from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Dropdown, List, message, Modal, Spin } from "antd";
import { useState } from "react";
import useTabSync from "../../customHooks/useTabSync";
import { useGlobalFilters } from "../../providers/GlobalFiltersProvider";
import OrgService from "../../services/Org/OrgService";

const UserDropdownMenu = ({ user, logout, collapsed }) => {
  const { resetGlobalFilters } = useGlobalFilters();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [orgs, setOrgs] = useState([]);
  const [loading, setLoading] = useState(false);
  const { broadcast } = useTabSync({});

  const fetchOrgs = async () => {
    setLoading(true);
    try {
      const response = await OrgService.getAllOrgsToSwitch();
      if (response.status === 200) {
        setOrgs(response.data);
      }
    } catch (error) {
      setIsModalVisible(false);
      console.error("Error Fetching Orgs:", error);
      message.error("Failed to fetch Orgs");
    } finally {
      setLoading(false);
    }
  };

  const showModal = async () => {
    setIsModalVisible(true);
    await fetchOrgs();
  };

  const handleSwitchOrg = (newOrgId) => {
    setLoading(true);
    try {
      OrgService.switchPrimaryOrg(newOrgId).then((response) => {
        if (response.status === 200) {
          resetGlobalFilters();
          broadcast("ORG_SWITCHED");
          window.location.replace("/");
        }
      });
    } catch {
      message.error("Failed to switch Org");
    } finally {
      setLoading(false);
      setIsModalVisible(false);
    }
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setOrgs([]);
  }

  const handleMenuClick = (e) => {
    switch (e?.key) {
      case "switchOrg":
        showModal();
        break;
      case "logout":
        logout();
        message.success("Logged Out Successfully");
        break;
      default:
        break;
    }
  };

  const items = [
    {
      key: "switchOrg",
      label: "Switch Org",
      icon: <FontAwesomeIcon icon={faBuildings} />,
    },
    {
      key: "logout",
      label: "Logout",
      icon: <FontAwesomeIcon icon={faRightFromBracket} />,
      danger: true,
    },
  ];

  const menuProps = {
    items,
    onClick: handleMenuClick,
  };

  return (
    <>
      <Dropdown
        menu={menuProps}
        placement="bottomLeft"
        trigger={["click"]}
        className="w-full"
      >
        <Button type="link" onClick={(e) => e.preventDefault()}>
          {collapsed ? (
            <FontAwesomeIcon
              icon={faCircleUser}
              className="text-gray-900 hover:text-gray-600 text-[30px]"
            />
          ) : (
            <div className="flex w-full justify-between items-baseline text-gray-900 hover:text-gray-600">
              <div className="font-semibold text-[16px] text-left">
                {user?.name}<br /><span className="text-[14px] truncate block max-w-[222px]">{user?.orgName}</span>
              </div>
              <FontAwesomeIcon icon={faCaretDown} />
            </div>
          )}
        </Button>
      </Dropdown>

      <Modal
        title={<div className="text-[20px]">Switch Org<FontAwesomeIcon icon={faBuildings} className="ml-2 text-primary" /></div>}
        open={isModalVisible}
        onCancel={handleCancel}
        footer={null}
        width="auto"
        centered
        maskClosable={false}
        closeIcon={<FontAwesomeIcon icon={faClose} className="text-[24px] mt-2" />}
      >
        {loading ? (
          <div className="flex justify-center">
            <Spin size="large" />
          </div>
        ) : (
          <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
            <List
              dataSource={orgs}
              bordered
              size="small"
              renderItem={(org) => (
                <List.Item
                  className={`${org.isPrimary ? "bg-blue-100" : "cursor-pointer hover:bg-blue-50"}`}
                  onClick={() => !org.isPrimary && handleSwitchOrg(org.id)}
                >
                  <div className="flex justify-between items-center w-full">
                    <span className="font-medium text-[18px]">{org.name}</span>
                    {org.isPrimary && <FontAwesomeIcon icon={faCircleCheck} className="text-success text-[24px] ml-2" />}
                  </div>
                </List.Item>
              )}
            />
          </div>
        )}
      </Modal>
    </>
  );
};

export default UserDropdownMenu;